import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export default function QLabel(props){

  const { t, i18n } = useTranslation()
    return(
        <Fragment>
          {t(props.label)}
        </Fragment>
        
        )
}